<template>
    <v-container fluid grid-list-md>
        <v-layout column wrap>
            <v-flex>
                <h1 class="display-3">Listado de no conformidades</h1>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <v-card>
                    <v-toolbar flat>
                        <v-text-field v-model="search" label="Búsqueda"></v-text-field>
                        <v-btn @click="getTableData()">BUSCAR</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn flat color="green" dark to="/calidad/no-conformidad/agregar">
                            <v-icon left>add</v-icon>
                            Nuevo registro
                        </v-btn>
                    </v-toolbar>
                    <v-data-table
                            :headers="headers"
                            :items="items"
                            :pagination.sync="pag"
                            :total-items="totalItems"
                            :loading="loading"
                            :rows-per-page-items="rows"
                            rows-per-page-text="Filas por pagina"
                            no-data-text="No hay datos"
                            disable-initial-sort
                            item-key="id"
                    >
                        <template slot="items" slot-scope="props">
                            <td class="text-xs-center">{{ props.item.id }}</td>
                            <td class="text-xs-center">
                                <v-avatar :size="30" v-if="props.item.empresa && props.item.empresa.avatar">
                                    <img :src="props.item.empresa.avatar" alt="avatar">
                                </v-avatar>
                            </td>
                            <td class="text-xs-center"> {{ (props.item.origen)? props.item.origen.desig :''}}</td>
                            <td class="text-xs-center">{{ props.item.resumen }}</td>
                            <td class="text-xs-center">{{ (props.item.usuario)?props.item.usuario.name: '' }}</td>
                            <td class="text-xs-center">{{ (props.item.gestor)?props.item.gestor.name: '' }}</td>
                            <td class="text-xs-center">{{ (props.item.presupuesto)?props.item.presupuesto: '' }}</td>
                            <td class="text-xs-center">{{ (props.item.pv)?props.item.pv: '' }}</td>
                            <td class="text-xs-center">{{ (props.item.producto)?props.item.producto: '' }}</td>
                            <td class="text-xs-right"> {{ props.item.cant }} {{ props.item.um}}</td>
                            <td class="text-xs-center">{{ (props.item.etapa)? props.item.etapa.desig : '' }}</td>
                            <td class="text-xs-center">
                                <v-btn color="green" flat icon @click.native="$router.push('/calidad/no-conformidad/gestion/' + props.item.id)">
                                    <v-icon>edit</v-icon>
                                </v-btn>
                            </td>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import mixinIncidencia from '../../../mixins/calidad/incidencia';

    export default {
        name: "no_conformidad",
        mixins: [mixinIncidencia],
        data: () => {
            return {
                loading: false,
                headers: [
                    {text: 'ID', value: 'id', align: 'center'},
                    {text: 'Empresa', value: 'empresa_id', align: 'center'},
                    {text: 'Origen', value: 'origen_id', align: 'center'},
                    {text: 'Resumen', value: 'resumen', align: 'center'},
                    {text: 'Usuario', value: 'usuario', align: 'center'},
                    {text: 'Gestor', value: 'gestor_id', align: 'center'},
                    {text: 'Presupuesto', value: 'presupuesto', align: 'center'},
                    {text: 'Pedido de Vta', value: 'pv', align: 'center'},
                    {text: 'Producto', value: 'producto', align: 'center'},
                    {text: 'Cant. reclam.', value: 'cant', align: 'center'},
                    {text: 'Estado', value: 'incidencia_estado_id', align: 'center'},
                    {text: 'Oper', value: '', align: 'center'},
                ],
                items: [],
                search: '',
                pag: {},
                rows: [10, 20, 30, {text: 'Todo', value: -1}],
                totalItems: 0,
            }
        },
        watch: {
            pag: {
                handler() {
                    this.getTableData();
                },
                deep: true
            }
        },
        mounted() {
            this.getTableData();
        },
        methods: {
            getTableData() {
                this.pag.search = this.search;
                this.incidenciaIndex(this.pag, r => {
                    this.items = r.data;
                    this.totalItems = r.total;
                    this.loading = false;
                }, err => {
                    console.error(err);
                })
            }
        }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/calidad/no_conformidad/listado.vue